import loadable from "@loadable/component"
import { Navigate, RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"
import { useUserInfo } from "~/store/user/userSlice"

const BolRequestAvailabilityPage = loadable(
  async () =>
    import("~/features/bol-request-availability/pages/BolRequestAvailabilityPage"),
  { fallback: <></> },
)

const SuperAdminBolRequestAvailabilityRoute = () => {
  const { user } = useUserInfo()
  const isSuperAdmin = user?.user?.roles?.some(
    (role) => String(role) === "SuperAdmin",
  )

  return isSuperAdmin ? (
    <BolRequestAvailabilityPage />
  ) : (
    <Navigate replace to={APP_ROUTES.home} />
  )
}

export const bolRequestAvailabilityRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.bolRequestAvailability,
    element: <SuperAdminBolRequestAvailabilityRoute />,
  },
]
